import {KTSVG} from '../../../_metronic/helpers'
import React, {useEffect, useRef, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {
  useAllproductsandtypes,
  useAllproductunits,
  useAllproductcategories,
  useUpdateallproducts,
} from '../../contextProviders/Atomqueryprovider'
import {useAuth} from '../../../app/modules/auth'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import clsx from 'clsx'
import Select from 'react-select'
import { useSelectStyles } from '../../helpers/useSelectStyles'
import { useThemeMode } from '../../../_metronic/partials'
import EditableDiv from '../../helpers/components/EditableDiv'


type Props = {
  show: boolean
  handleClose: () => void
  producttoupdate: any
  sumstockrefetch: () => void
  allproductsrefetch: () => void
  variancerefetch: () => void
}

const initialValues = {
  product_name: '',
  units_in_stock: 0,
  unit_buying_price: 0,
  discount_percentage: 0,
  reorder_level: 0,
  product_category_id: '',
  product_unit_id: '',
  unit_selling_price: 0,
  product_description: '',
  product_division: 1,
  product_image: '',
  product_id: 0,
  product_file: '',
}
const API_URL = process.env.REACT_APP_API_URL
const FILE_SIZE = 1000000
const SUPPORTED_FORMATS = ['image/png']

const productSchema = Yup.object().shape({
  units_in_stock: Yup.number().required('Stock units are required'),
  unit_buying_price: Yup.number().required('Unit buying price is required'),
  reorder_level: Yup.number().required('Reorder level is required'),
  product_category_id: Yup.string().required('Product category is required'),
  product_unit_id: Yup.string().required('Product unit is required'),
  discount_percentage: Yup.number().required('Unit discount is required'),
  unit_selling_price: Yup.number().required('Unit selling price is required'),
  // product_image: Yup.mixed().required('A product picture is required').test(
  //   "fileSize",
  //         "File too large",
  //         value => value && value.size <= FILE_SIZE
  // ).test(
  //   "fileFormat",
  //   "Unsupported Format",
  //   value => value && SUPPORTED_FORMATS.includes(value.type)
  // ),
  product_description: Yup.string().required('Product description is required'),
  product_division: Yup.number().required('A product division is required'),
})

export const Updateproduct: React.FC<Props> = ({
  show,
  handleClose,
  producttoupdate,
  sumstockrefetch,
  allproductsrefetch,
  variancerefetch,
}) => {
  const [loading, setLoading] = useState(false)
  const [changedfileinputdata, setChangedfileinputdata] = useState<boolean>(false)
  const [products_unit, setProducts_unit] = useState<any>([])
  const [loadedProducts_category, setLoadedProducts_category] = useState(false)
  const [products_category, setProducts_category] = useState<any>([])
  const [productadded, setProductadded] = useState<any>({})
  const [submittingready, setSubmittingready] = useState<boolean>(false)
 
  const {currentUser} = useAuth()
  const [fileContent, setFileContent] = useState('')
  const fileInputRef = useRef<HTMLInputElement | any>(null)
  const {mode} = useThemeMode()

 

  const getFormData: any = <T extends Record<string, any>>(obj: T): FormData =>
    Object.entries(obj).reduce((formData: FormData, [key, value]) => {
      if (value instanceof FileList) {
        for (let i = 0; i < value.length; i++) {
          formData.append(key, value[i])
        }
      } else {
        formData.append(key, value)
      }
      return formData
    }, new FormData())

  const {mutateAsync: updateallproductsmutateAsync} = useUpdateallproducts(
    getFormData(productadded)
  )

  const product_division = [
    {value: 0.25, label: 0.25},
    {value: 0.5, label: 0.5},
    {value: 0.75, label: 0.75},
    {value: 1, label: 1},
  ]

  const formik = useFormik({
    initialValues,
    validationSchema: productSchema,
    validateOnBlur: true,
    onSubmit: async (values, {setStatus, setSubmitting, resetForm}) => {
      setLoading(true)

      setProductadded({
        product_image: values.product_image,
        user_id: currentUser?.user_id,
        discount_percentage: values.discount_percentage,
        product_name: values.product_name,
        product_id: values.product_id,
        units_in_stock: values.units_in_stock,
        unit_buying_price: values.unit_buying_price,
        reorder_level: values.reorder_level,
        product_category_id: values.product_category_id,
        product_unit_id: values.product_unit_id,
        unit_selling_price: values.unit_selling_price,
        product_description: values.product_description,
        product_division: values.product_division,
        product_file: values.product_file,
      })

      setSubmittingready(true)
    },
  })

  useEffect(() => {
    if (submittingready && productadded) {

      
      updateallproductsmutateAsync(getFormData(productadded), {
        onSuccess: () => {
          setLoading(false)
          formik.resetForm({})
          formik.setSubmitting(false)
          setProductadded({})
          sumstockrefetch()
          allproductsrefetch()
          variancerefetch()
          setSubmittingready(false)
          handleClose()
        },
        onError(error, variables, context) {
          formik.setStatus('The product details are incorrect')
          formik.setSubmitting(false)
          setLoading(false)
        },
      })
    }
  }, [submittingready])

  const {
    isLoading: allproductcategoriesloading,
    isSuccess: allproductcategoriessuccess,
    data: allproductcategoriesdata,
    status: allproductcategoriesstatus,
    refetch: allproductcategoriesrefetch,
  } = useAllproductcategories()

  const {
    isLoading: allproductunitsloading,
    isSuccess: allproductunitssuccess,
    data: allproductunitsdata,
    status: allproductunitsstatus,
    refetch: allproductunitsrefetch,
  } = useAllproductunits()

  useEffect(() => {
    if (producttoupdate) {
      const dataTransfer = new DataTransfer()

      const filenow = new File([''], producttoupdate.product_image, {type: 'image/png'})

      dataTransfer.items.add(filenow)

      formik.setFieldValue('product_name', producttoupdate.product_name)
      formik.setFieldValue('units_in_stock', producttoupdate.units_in_stock)
      formik.setFieldValue('unit_buying_price', producttoupdate.unit_buying_price)
      formik.setFieldValue('unit_selling_price', producttoupdate.unit_selling_price)
      formik.setFieldValue('discount_percentage', producttoupdate.discount_percentage)
      formik.setFieldValue('reorder_level', producttoupdate.reorder_level)
      formik.setFieldValue('product_id', producttoupdate.product_id)
      formik.setFieldValue('product_description', producttoupdate.product_description)
      formik.setFieldValue('product_category_id', producttoupdate.product_category_id)
      formik.setFieldValue('product_image', producttoupdate.product_image)
      formik.setFieldValue('product_unit_id', producttoupdate.product_unit_id)
      if (fileInputRef.current) {
        fileInputRef.current.files = dataTransfer.files
      }
    }
  }, [producttoupdate])

  useEffect(() => {
    if (changedfileinputdata) {
      const file = fileInputRef.current.files[0]
      formik.setFieldValue('product_file', file)
      formik.setFieldValue('product_image', file.name)
      setChangedfileinputdata(false)
    }
  }, [changedfileinputdata])

  return (
    <Modal
      className='modal fade'
      id='kt_modal_dashboard'
      data-backdrop='static'
      tabIndex={-1}
      role='dialog'
      show={show}
      centered
      dialogClassName='modal-lg'
      aria-hidden='true'
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h3 className='fw-bolder'>
            Update Product
            <span className='h-10px border-gray-200 border-start mx-2'></span>
            <span className='text-muted fw-bold fs-6'>{producttoupdate.product_id}</span>
          </h3>

          <div className='d-flex align-items-center'>
            

            <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
              <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
            </div>
          </div>
        </div>
        <div className='modal-body'>
          <form
            id='kt_modal_add_update_product_form'
            noValidate
            className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
            onSubmit={formik.handleSubmit}
          >
            {/* begin::Input group */}
            <div className='fv-row mb-7'>
              <div className='row'></div>
              {/* begin::Label */}
              <label className='required fw-bold fs-6 mb-2'>
                Product Name <span className='text-primary'>(Not Updateable)</span>
              </label>
              {/* end::Label */}

              <input
                disabled={true}
                style={{ backgroundColor: 'rgba(255, 192, 203, 0.2)' }}
                type='text'
                {...formik.getFieldProps('product_name')}
                className={clsx(
                  'form-control form-control-lg form-control-solid',
                  {
                    'is-invalid': formik.touched.product_name && formik.errors.product_name,
                  },
                  {
                    'is-valid': formik.touched.product_name && !formik.errors.product_name,
                  }
                )}
              />
              {formik.touched.product_name && formik.errors.product_name && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span role='alert'>{formik.errors.product_name}</span>
                  </div>
                </div>
              )}
            </div>
            {/* end::Input group */}

            {/* begin::Input group */}

            <div className='row fv-row mb-7'>
              <div className='col-xl-6'>
                {/* begin::Form group second_name */}
                <div className='fv-row mb-7'>
                  <label className='required fw-bold fs-6 mb-2'>Units in Stock</label>
                  <input
                    placeholder='0'
                    type='number'
                    {...formik.getFieldProps('units_in_stock')}
                    autoComplete='off'
                    className={clsx(
                      'form-control form-control-lg form-control-solid',
                      {
                        'is-invalid': formik.touched.units_in_stock && formik.errors.units_in_stock,
                      },
                      {
                        'is-valid': formik.touched.units_in_stock && !formik.errors.units_in_stock,
                      }
                    )}
                  />
                  {formik.touched.units_in_stock && formik.errors.units_in_stock && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.units_in_stock}</span>
                      </div>
                    </div>
                  )}
                </div>
                {/* end::Form group */}
              </div>
              <div className='col-xl-6'>
                {/* begin::Form group second_name */}
                <div className='fv-row mb-7'>
                  <label className='required fw-bold fs-6 mb-2'>Unit Buying Price</label>
                  <input
                    type='number'
                    autoComplete='off'
                    placeholder='0.00'
                    {...formik.getFieldProps('unit_buying_price')}
                    className={clsx(
                      'form-control form-control-lg form-control-solid',
                      {
                        'is-invalid':
                          formik.touched.unit_buying_price && formik.errors.unit_buying_price,
                      },
                      {
                        'is-valid':
                          formik.touched.unit_buying_price && !formik.errors.unit_buying_price,
                      }
                    )}
                  />
                  {formik.touched.unit_buying_price && formik.errors.unit_buying_price && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.unit_buying_price}</span>
                      </div>
                    </div>
                  )}
                </div>
                {/* end::Form group */}
              </div>
            </div>

            {/* end::Input group */}

            {/* begin::Input group */}

            <div className='row fv-row mb-7'>
              <div className='col-xl-6'>
                {/* begin::Form group second_name */}
                <div className='fv-row mb-7'>
                  <label className='required fw-bold fs-6 mb-2'>Reorder Level</label>
                  <input
                    placeholder='0'
                    type='number'
                    autoComplete='off'
                    {...formik.getFieldProps('reorder_level')}
                    className={clsx(
                      'form-control form-control-lg form-control-solid',
                      {
                        'is-invalid': formik.touched.reorder_level && formik.errors.reorder_level,
                      },
                      {
                        'is-valid': formik.touched.reorder_level && !formik.errors.reorder_level,
                      }
                    )}
                  />
                  {formik.touched.reorder_level && formik.errors.reorder_level && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.reorder_level}</span>
                      </div>
                    </div>
                  )}
                </div>
                {/* end::Form group */}
              </div>
              <div className='col-xl-6'>
                {/* begin::Form group second_name */}
                <div className='fv-row mb-7'>
                  <label className='required fw-bold fs-6 mb-2'>Product Category</label>
                  <Select
                    styles={useSelectStyles()}
                    isLoading={allproductcategoriesloading}
                    isClearable={true}
                    isSearchable={true}
                    placeholder={"Select product category ..."}
                    options={
                      allproductcategoriessuccess &&
                      allproductcategoriesdata?.data.map((x: any) => {
                        return {value: x.product_category_id, label: x.category_name}
                      })
                    }
                    defaultValue={{
                      value: producttoupdate.product_category_id,
                      label: allproductcategoriesdata?.data
                        .filter(
                          (x: any) => x.product_category_id === producttoupdate.product_category_id
                        )
                        .map((x: any) => x.category_name)[0],
                    }}
                    onChange={(selectedOption: any) =>
                      formik.setFieldValue('product_category_id', selectedOption.value)
                    }
                  />
                  {formik.touched.product_category_id && formik.errors.product_category_id && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.product_category_id}</span>
                      </div>
                    </div>
                  )}
                </div>
                {/* end::Form group */}
              </div>
            </div>

            {/* end::Input group */}

            {/* begin::Input group */}

            <div className='row fv-row mb-7'>
              <div className='col-xl-6'>
                {/* begin::Form group second_name */}
                <div className='fv-row mb-7'>
                  <label className='required fw-bold fs-6 mb-2'>Product Unit</label>
                  <Select
                    styles={useSelectStyles()}
                    isLoading={allproductunitsloading}
                    isClearable={true}
                    isSearchable={true}
                    placeholder={"Select product unit ..."}
                    defaultValue={{
                      value: producttoupdate.product_unit_id,
                      label: allproductunitsdata?.data
                        .filter((x: any) => x.product_unit_id === producttoupdate.product_unit_id)
                        .map((x: any) => x.unit_name)[0],
                    }}
                    options={
                      allproductunitssuccess &&
                      allproductunitsdata?.data.map((x: any) => {
                        return {value: x.product_unit_id, label: x.unit_name}
                      })
                    }
                    onChange={(selectedOption: any) =>
                      formik.setFieldValue('product_unit_id', selectedOption.value)
                    }
                  />
                  {formik.touched.product_unit_id && formik.errors.product_unit_id && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.product_unit_id}</span>
                      </div>
                    </div>
                  )}
                </div>
                {/* end::Form group */}
              </div>
              <div className='col-xl-6'>
                {/* begin::Form group second_name */}
                <div className='fv-row mb-7'>
                  <label className='required fw-bold fs-6 mb-2'>Unit Selling Price</label>
                  <input
                    type='number'
                    autoComplete='off'
                    placeholder='0.00'
                    {...formik.getFieldProps('unit_selling_price')}
                    className={clsx(
                      'form-control form-control-lg form-control-solid',
                      {
                        'is-invalid':
                          formik.touched.unit_selling_price && formik.errors.unit_selling_price,
                      },
                      {
                        'is-valid':
                          formik.touched.unit_selling_price && !formik.errors.unit_selling_price,
                      }
                    )}
                  />
                  {formik.touched.unit_selling_price && formik.errors.unit_selling_price && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.unit_selling_price}</span>
                      </div>
                    </div>
                  )}
                </div>
                {/* end::Form group */}
              </div>
            </div>

            {/* end::Input group */}
            {/* begin::Input group */}

            <div className='row fv-row mb-7'>
              <div className='col-xl-6'>
                {/* begin::Form group second_name */}
                <div className='fv-row mb-7'>
                  <label className='required fw-bold fs-6 mb-2'>Product Division</label>
                  <Select
                    styles={useSelectStyles()}
                    isClearable={true}
                    isSearchable={true}
                    placeholder={"Select product division ..."}
                    options={product_division}
                    onChange={(selectedOption: any) =>
                      formik.setFieldValue('product_division', selectedOption.value)
                    }
                    defaultValue={{
                      value: producttoupdate.product_division,
                      label: product_division
                        .filter((x: any) => x.value === producttoupdate.product_division)
                        .map((x: any) => x.label)[0],
                    }}
                  />
                  {formik.touched.product_division && formik.errors.product_division && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.product_division}</span>
                      </div>
                    </div>
                  )}
                </div>
                {/* end::Form group */}
              </div>
              <div className='col-xl-6'>
                {/* begin::Form group second_name */}
                <div className='fv-row mb-7'>
                  <label className='required fw-bold fs-6 mb-2'>Product Image</label>
                  <input
                    id='product_image'
                    type='file'
                    accept='image/*'
                    name='product_image'
                    ref={fileInputRef}
                    onChange={(event: any) => {
                      setChangedfileinputdata(true)
                      formik.setFieldValue('product_image', event.currentTarget.files[0])
                    }}
                    className={'form-control form-control-lg form-control-solid text-primary'}
                  />
                  {formik.touched.product_image && formik.errors.product_image && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.product_image}</span>
                      </div>
                    </div>
                  )}
                </div>
                {/* end::Form group */}
              </div>
            </div>

            {/* end::Input group */}
            {/* begin::Input group */}

            <div className='row fv-row mb-7'>
              <div className='col-xl-6'>
                {/* begin::Form group second_name */}
                <div className='fv-row mb-7'>
                  <label className='required fw-bold fs-6 mb-2'>Product Discount Percentage</label>
                  <input
                    placeholder='0'
                    type='number'
                    {...formik.getFieldProps('discount_percentage')}
                    autoComplete='off'
                    className={clsx(
                      'form-control form-control-lg form-control-solid',
                      {
                        'is-invalid':
                          formik.touched.discount_percentage && formik.errors.discount_percentage,
                      },
                      {
                        'is-valid':
                          formik.touched.discount_percentage && !formik.errors.discount_percentage,
                      }
                    )}
                  />
                  {formik.touched.discount_percentage && formik.errors.discount_percentage && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.discount_percentage}</span>
                      </div>
                    </div>
                  )}
                </div>
                {/* end::Form group */}
              </div>
              <div className='col-xl-6'>
                {/* begin::Form group second_name */}
                <div className='fv-row mb-7'>
                  <label className='required fw-bold fs-6 mb-2'>
                    Product ID <span className='text-primary'>(Not Updateable)</span>
                  </label>
                  <input
                    disabled={true}
                    style={{ backgroundColor: 'rgba(255, 192, 203, 0.2)' }}
                    type='number'
                    {...formik.getFieldProps('product_id')}
                    className={clsx(
                      'form-control form-control-lg form-control-solid',
                      {
                        'is-invalid': formik.touched.product_id && formik.errors.product_id,
                      },
                      {
                        'is-valid': formik.touched.product_id && !formik.errors.product_id,
                      }
                    )}
                  />
                  {formik.touched.product_id && formik.errors.product_id && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.product_id}</span>
                      </div>
                    </div>
                  )}
                </div>
                {/* end::Form group */}
              </div>
            </div>

            {/* end::Input group */}

            {/* begin::Input group */}
            <div className='fv-row mb-7'>
              {/* begin::Label */}
              <label className='required fw-bold fs-6 mb-2'>Product Description</label>
              {/* end::Label */}

              <div className='d-flex flex-column flex-grow-1'>
                <div className='d-flex flex-wrap'>
                  <div className='col-12'>
                    
                  <EditableDiv
                      placeholder='Add a description here ...'
                      initialContent={formik.values.product_description}
                      onChange={(x: any)=> formik.setFieldValue('product_description', x)}
                      className={clsx(
                        'form-control form-control-lg form-control-solid',
                        {
                          'is-invalid':
                            formik.touched.product_description && formik.errors.product_description,
                        },
                        {
                          'is-valid':
                            formik.touched.product_description &&
                            !formik.errors.product_description,
                        }
                      )}
                      
                   /> 
                   

                    {formik.touched.product_description && formik.errors.product_description && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>
                          <span role='alert'>{formik.errors.product_description}</span>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {/* end::Input group */}
          </form>
        </div>
        <div className='modal-footer border-0 mt-n5'>
          <button type='button' className='btn btn-light-primary' onClick={handleClose}>
            Cancel
          </button>

          <button
            type='submit'
            form='kt_modal_add_update_product_form'
            className='btn btn-info'
            disabled={formik.isSubmitting || !formik.isValid || !formik.dirty}
          >
            {!loading && <span className='indicator-label'>Update Product</span>}
            {loading && (
              <span className='indicator-progress' style={{display: 'block'}}>
                Please wait...{' '}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
        </div>
      </div>
    </Modal>
  )
}